import { Component, Input, OnChanges } from '@angular/core';
import { IPedidoNaoLiberadoCardInfoLimiteCreditoExcedidoSettings } from './pedido-nao-liberado-card-info-limite-credito-excedido-settings.interface';
import { ITableSettings } from '../../../../../domains/shared/components/table/interfaces/table-settings.interface';
import { IPedidoEmAberto } from '../../../interfaces/pedido-em-aberto.interface';

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info-limite-credito-excedido',
    templateUrl: './pedido-nao-liberado-card-info-limite-credito-excedido.component.html'
})
export class PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoComponent implements OnChanges {
    @Input() settings!: IPedidoNaoLiberadoCardInfoLimiteCreditoExcedidoSettings;

    tableSettings: ITableSettings = {
        loading: false,
        isEmpty: true,
        showFooter: false,
        showDisplayCounterRecords: false,
        customContainerClass: 'table-modern table-modern--condensed'
    };

    ngOnChanges(): void {
        const pedidos = this.settings?.pedidosEmAbertoNaoLiberado ?? [];
        this.tableSettings = {
            ...this.tableSettings,
            isEmpty: pedidos.length === 0
        };
    }

    trackByPedidoId(_index: number, pedido: IPedidoEmAberto): number {
        return pedido.id;
    }
}
